import * as React from "react";
import Icon from "react-icons-kit";
import { Alert } from "react-bootstrap";

import "./CustomAlert.css";

interface CustomAlertProps {
    bsStyle: "success" | "warning" | "danger" | "info";
    icon: any;
    message: string;
    additionalContent?: React.ReactNode;
}

export const CustomAlert: React.FC<CustomAlertProps> = ({ bsStyle, icon, message, additionalContent }) => {
    return (
        <Alert bsStyle={bsStyle}>
            <div>
                <Icon icon={icon} size={32} style={{verticalAlign: "top"}}/>
                <strong className="custom-alert-title">{message}</strong>
            </div>
            <div  className="custom-alert-message">
                {additionalContent}
            </div>
        </Alert>
    );
};


// WEBPACK FOOTER //
// ./src/components/genericComponents/CustomAlert.tsx